<div class='mt-4'>
  <input
    class='input is-primary'
    type="checkbox"
    name="validate"
    id="validate"
    value="is_triamudom"
    bind:checked={$checked}
    required={false}
  >
  <label for="validate">{label}</label><br>
</div>

<script lang='ts'>
  import type { Writable } from "svelte/store";
  import { writable } from "svelte/store";

  export let label: string | null = null;
  export let checked: Writable<boolean> = writable(false);
</script>
